import { useState, useEffect } from 'react'

const useMouseDrag = (): boolean => {
  const [upCoordX, setUpCoordX] = useState<number>(0)
  const [upCoordY, setUpCoordY] = useState<number>(0)
  const [downCoordX, setDownCoordX] = useState<number>(0)
  const [downCoordY, setDownCoordY] = useState<number>(0)

  useEffect(() => {
    document.body.addEventListener('mousedown', handleMouseDown)
    document.body.addEventListener('mouseup', handleMouseUp)

    function removeListeners() {
      document.body.removeEventListener('mousedown', handleMouseDown)
      document.body.removeEventListener('mouseup', handleMouseUp)
    }

    return removeListeners
  }, [])

  function handleMouseDown(e: MouseEvent) {
    setDownCoordX(e.clientX)
    setDownCoordY(e.clientY)
  }

  function handleMouseUp(e: MouseEvent) {
    setUpCoordX(e.clientX)
    setUpCoordY(e.clientY)
  }

  const isDragX = Math.abs(upCoordX - downCoordX) > 10
  const isDragY = Math.abs(upCoordY - downCoordY) > 10

  return isDragX || isDragY
}

export default useMouseDrag
